/**
 * Must be the first import in the app, and must not be removed.
 *
 * antd v5's static calls — `message.*`, `notification.*` and
 * `Modal.confirm/info/success/error/warning` — render through `ReactDOM.render`,
 * which React 19 deleted. Without this patch they do not throw: they silently
 * do nothing, so a toast simply never appears and there is no error to trace.
 *
 * It looks like an unused import because nothing in the app calls those APIs
 * today (every alert goes through sweetalert2). It is here so that the first
 * one that does works. See index.test.tsx, which fails if this line goes away.
 */
import '@ant-design/v5-patch-for-react-19';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import antdTheme from './theme/antdTheme';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ConfigProvider theme={antdTheme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
